import { PLAN_KEY } from '../../../../modules/plan/model'
import { PLAN_CLASS_NAME } from '../../../plan'
import updateCurrentPlanAction from '../set-current'
import PLANS_ACTION from '../../constants/action'
import PLANS_PATH from '../../constants/path'
import { getCurrentProfileSelect } from '../../../profile/redux/selectors/get-current'
import createReduxAction from '../../../redux/actions/create'
import { getIdReduxUtil } from '../../../redux/utils/get-id'
import { createISOStrDateUtil } from 'packages/src'

function createPlanAction () {
  return (dispatch, getState) => {
    const now = createISOStrDateUtil()
    return dispatch(createReduxAction({
      type: PLANS_ACTION.CREATE,
      payload: {
        domainListPath: PLANS_PATH.NON_LOGGED,
        data: {
          className: PLAN_CLASS_NAME,
          changed: {
            [PLAN_KEY.NAME]: '',
            [PLAN_KEY.AUTHOR_ID]: getIdReduxUtil(getCurrentProfileSelect(
              getState())),
            [PLAN_KEY.NOTES]: '',
            [PLAN_KEY.EQUIPMENT]: [],
            [PLAN_KEY.WORKOUTS_COUNT]: 0,
            [PLAN_KEY.WORKOUTS_COMPLETED_COUNT]: 0,
            [PLAN_KEY.WEEKS_COUNT]: 0,
            [PLAN_KEY.CREATED_AT]: now,
            [PLAN_KEY.UPDATED_AT]: now,
            [PLAN_KEY.WORKOUTS]: []
          }
        }
      }
    }))
  }
}

function createPlanAndSetAction () {
  return (dispatch) => {
    const plan = dispatch(createPlanAction())
    dispatch(updateCurrentPlanAction(plan))
    return plan
  }
}

export {
  createPlanAction,
  createPlanAndSetAction
}
